import { useEffect, useState } from 'react';

const STORAGE_KEY = 'velora.admin.sidebar.collapsed';

// Module-level store so AdminShell (owner) and ProductShell's top bar
// (which renders the toggle button) can share the same collapsed state.
let current = typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY) === '1';
const listeners = new Set<(v: boolean) => void>();

function set(v: boolean) {
  current = v;
  try { window.localStorage.setItem(STORAGE_KEY, v ? '1' : '0'); } catch { /* ignore */ }
  listeners.forEach((cb) => cb(v));
}

export function useAdminSidebar() {
  const [collapsed, setLocal] = useState<boolean>(current);
  useEffect(() => {
    const cb = (v: boolean) => setLocal(v);
    listeners.add(cb);
    return () => { listeners.delete(cb); };
  }, []);
  return {
    collapsed,
    toggle: () => set(!current),
    width: collapsed ? 56 : 214,
  };
}
